import { PortalButton } from '@vs/ui/portal/button';
import { mainBlockID } from '@vs/ui/portal/layout';
import { useTranslation } from 'react-i18next';

import styles from './btn-skip-to-main.module.css';
import { focusTargetById } from './focus-target-by-id';

export function BtnSkipToMain() {
  const { t } = useTranslation('shared');

  return (
    <PortalButton
      className={styles['skip-to-content']}
      label={t('aria_label.btn_skip_to_main')}
      size="md"
      type="secondary"
      variant="contained"
      onClick={() => focusTargetById({ id: mainBlockID })}
    />
  );
}

export default BtnSkipToMain;
